import React from 'react';

import PropTypes from 'prop-types';

import { DataTable } from '../../../../shared/components/DataTable';
import { Pagination, RecordCount } from '../../../../shared/components/Pagination';
import { useDecedentData } from '../../hooks';
import columns from './columns';
import DataTableSkeleton from './DataTableSkeleton';
import NewDialog from './NewDialog';

const RECORD_TYPE = 'decedents';

const Decedents = ({ onCloseDialog, searchQuery, showDialog }) => {
  const { decedents, fetchDecedents, handlePageChange, isLoading, pagination } =
    useDecedentData(searchQuery);

  return (
    <>
      <div className="flex flex-col gap-2">
        {isLoading ? (
          <DataTableSkeleton />
        ) : (
          <DataTable columns={columns} data={decedents} />
        )}

        <div className="flex items-center justify-end gap-4 mr-3.5">
          <RecordCount
            from={pagination.from}
            isLoading={isLoading}
            recordType={RECORD_TYPE}
            to={pagination.to}
            totalRecords={pagination.totalRecords}
          />

          <Pagination
            currentPage={pagination.currentPage}
            isLoading={isLoading}
            onPageChange={handlePageChange}
            totalPages={pagination.totalPages}
          />
        </div>
      </div>

      <NewDialog isOpen={showDialog} onClose={onCloseDialog} onSuccess={fetchDecedents} />
    </>
  );
};

Decedents.propTypes = {
  onCloseDialog: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  showDialog: PropTypes.bool.isRequired,
};

export default Decedents;
